import {
  Inject,
  Injectable,
  Renderer2,
  RendererFactory2,
  DOCUMENT,
} from '@angular/core';
import { get } from 'es-cookie';
import { UserAgentService } from '../user-agent/user-agent.service';
import { WindowRefService } from '../window-ref/window-ref.service';

// A service to manage operations on the browser DOM.
@Injectable({
  providedIn: 'root',
})
export class DomService {
  private renderer: Renderer2;
  private arrowKeysListener: null | ((event: KeyboardEvent) => void);
  private windowScrollY: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private rendererFactory: RendererFactory2,
    private userAgentService: UserAgentService,
    private windowRef: WindowRefService,
  ) {
    this.document = document as Document;
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  getCookie(cookie: string): string | undefined {
    return get(cookie);
  }

  lockBody(): void {
    const userAgent = this.userAgentService.checkUserAgent();
    this.renderer.addClass(this.document.documentElement, 'lock-body');

    if (userAgent === 'iOS' || userAgent === 'iOSSafari') {
      this.windowScrollY = this.windowRef.nativeWindow.scrollY;
      this.renderer.addClass(this.document.body, 'lock-body');
    }
  }

  unlockBody(): void {
    const userAgent = this.userAgentService.checkUserAgent();
    this.renderer.removeClass(this.document.documentElement, 'lock-body');
    this.renderer.removeClass(this.document.body, 'lock-body');

    if (userAgent === 'iOS' || userAgent === 'iOSSafari') {
      this.windowRef.nativeWindow.scroll({ top: this.windowScrollY });
    }
  }

  setDirection(dir: 'ltr' | 'rtl'): void {
    this.renderer.setAttribute(this.document.documentElement, 'dir', dir);
  }

  preventArrowKeysScroll(): void {
    if (!this.arrowKeysListener) {
      this.arrowKeysListener = this.handleArrowKeys;
      this.document.addEventListener('keydown', this.arrowKeysListener);
    }
  }

  releasePreventArrowKeysScroll(): void {
    if (this.arrowKeysListener) {
      this.document.removeEventListener('keydown', this.arrowKeysListener);
      this.arrowKeysListener = null;
    }
  }

  private handleArrowKeys(event: KeyboardEvent): void {
    const NAVIGATION_KEYS = ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp'];
    if (NAVIGATION_KEYS.includes(event.key)) {
      event.preventDefault();
    }
  }

  public addSecondaryBackgroundColorClass(): void {
    this.renderer.addClass(this.document.body, 'secondary-background-color');
  }

  public removeSecondaryBackgroundColorClass(): void {
    this.renderer.removeClass(this.document.body, 'secondary-background-color');
  }
}
